import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import WebService from "../Services/WebService";
import VerticalMenu from "./LeftMenu/VerticalMenu";
import Header from "./Header/Header";
let version = "1.0.40";

const Main = () => {
  const[visible, setVisible] = useState<boolean>(true)
 
  return (

     <div id="main-app" className={visible ? "layout-veritcle-menu" : "layout-veritcle-menu menumize-menu"}>
       {/* <VerticalMenu /> */}
         <VerticalMenu
        visible={visible}
        toggleClass=""
        onToggleHandler={(className:boolean)=>{setVisible(className)}}
        />
      <div className="app-body kpi-dahboard-page">
          <Header />
        <Outlet />
      </div>
    </div>
  );
};

export default Main;
